<template>
    <div class="page">
        
       
        <div class="page-content">

            <div class="container">
                <h2>Recuperar senha</h2>
            </div>


            <div class="">
                <form  method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">
                    <div class="list" style="margin-top: 16px">
                        <ul class="row">
                                      
                            <li class="item-content item-input col-100 mt-10">
                                <div class="item-inner">
                                    <div class="item-title item-label">Nova senha</div>
                                    <div class="item-input-wrap">
                                        <input type="password" placeholder="Informe a nova senha.." v-model="form.senha" class="form-control"/>
                                    </div>
                                </div>
                            </li>
                            <li class="item-content item-input col-100 mt-10">
                                <div class="item-inner">
                                    <div class="item-title item-label">Confirme a nova senha</div>
                                    <div class="item-input-wrap">
                                        <input type="password" placeholder="Informe a nova senha.." v-model="form.senhaConfirmacao" class="form-control"/>
                                    </div>
                                </div>
                            </li>                                                        
                        </ul>
                    </div>
                    <div class="block">

                        <button type="submit" class="link external button-large button button-fill">
                            <i class="las la-save"></i>
                            Salvar
                        </button>
                    </div>
                </form>

            </div>
        </div>
        
    </div>     
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'
export default {
    name: 'AlterarSenha',
    components: {
        'Toolbar': Toolbar,
        'Top': Top,
    },          
    data () {
        var self                    = this;
        return {
            loading: {
                "submit":           false,
            },
            form: {
                "_cod":             self.$root.user.cod,
                "recuperarSenha":       "",
                "senha":            "",
                "senhaConfirmacao": ""
            }              
        }
    },
    methods: {
        submit: function(e) {
            var self            = this;
            console.log("submit", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
            
            axios.put("api/recuperar-senha.php", self.form)
            .then(response => {
                self.loading.submit = false;
                console.log("ok", response)
                loading.hide();
                alert(response.data.message);
                self.$router.push({ 
                    name:       "Login",
                }).catch(()=>{});              
            })
            .catch(error => {
                loading.hide();
                self.loading.submit = false;
                alert(error.response.data.message || "Erro! Por favor, tente novamente.");
            });

        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": self.form
                };

                axios.get("api/recuperar-senha.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    if (!response.data.result.cod) {
                        self.$router.push({ 
                            name:       "Login",
                        }).catch(()=>{});                              
                        return false;
                    }
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$router.push({ 
                                name:       "Login",
                            }).catch(()=>{});                                  
                        }
                    }                    
                });   
            });   
        }  
    }, 
    created: function() {
        var self = this;
        if (!self.$route.query.c || !self.$route.query.rs) {
            self.$router.push({ 
                name:       "Login",
            }).catch(()=>{});                  
            return false;
        }
        self.form._cod              = self.$route.query.c;        
        self.form.recuperarSenha    = self.$route.query.rs;  
        self.get();      
    },  
    mounted: function() {
       
        loading.hide();
    }   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
   
</style>



// WEBPACK FOOTER //
// src/components/RecuperarSenha.vue